import { render, staticRenderFns } from "./bottomTip.vue?vue&type=template&id=045ad5cf&scoped=true"
import script from "./bottomTip.vue?vue&type=script&lang=js"
export * from "./bottomTip.vue?vue&type=script&lang=js"
import style0 from "./bottomTip.vue?vue&type=style&index=0&id=045ad5cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045ad5cf",
  null
  
)

export default component.exports